/* eslint-disable no-underscore-dangle */
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { bool, func, object, oneOfType, string } from 'prop-types';
import client from '../../../api/api';
import HumberDropdown from '../../../libs/humber-dropdown';

const InputProviderWrap = styled.div`
  label {
    width: 100%;
    font-weight: 600;
    color: gray;
  }

  input {
    background: transparent;
    border: none;
    height: 45px;
    font-size: 16px;
    color: white;
    width: 100%;
    border-bottom: 1px solid #787878;
  }

  input:focus {
    outline: none;
  }
`;

const InputProvider = ({
  label,
  value,
  setValue,
  id,
  onBlurValidation,
  type,
  disabled,
  setErrorMsg,
}) => {
  const [list, setList] = useState([]);

  const getSelectOptions = useCallback(async () => {
    try {
      const { data } =
        id === 'truck-type'
          ? await client.endpoints.carrier.getTruckTypes()
          : await client.endpoints.carrier.getBodyTypeList();
      setList(data.sort((a, b) => a.label.localeCompare(b.label)));
    } catch (error) {
      setErrorMsg(
        id === 'truck-type'
          ? 'Error al obtener listado de tipos de camión'
          : 'Error al obtener listado de carrocerías'
      );
    }
  }, [id, setErrorMsg]);

  useEffect(() => {
    if (type === 'select') {
      getSelectOptions();
    }
  }, [getSelectOptions, type]);

  const handleChange = (e, key) => {
    e.preventDefault();
    if (key === 'cuit' && e.currentTarget.value.length < 12) {
      setValue(e.target.value);
    }

    if (key === 'cbu' && e.currentTarget.value.length < 23) {
      setValue(e.target.value);
    }
  };

  return (
    <InputProviderWrap>
      {type === 'select' && list.length > 0 ? (
        <HumberDropdown
          list={list}
          label={label}
          htmlFor={id}
          id={id}
          value={value}
          onChange={setValue}
          required
        />
      ) : (
        ''
      )}
      {id === 'cuit' ? (
        <label htmlFor={id}>
          {label}
          <input
            id={id}
            type="text"
            value={value}
            onKeyPress={event => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onBlur={() => onBlurValidation(value)}
            onChange={e => {
              handleChange(e, id);
            }}
            disabled={disabled}
          />
        </label>
      ) : (
        ''
      )}
      {id === 'cbu' ? (
        <label htmlFor={id}>
          {label}
          <input
            id={id}
            type="text"
            value={value}
            onKeyPress={event => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onChange={e => {
              handleChange(e, id);
            }}
            disabled={disabled}
          />
        </label>
      ) : (
        ''
      )}
      {id !== 'cbu' && id !== 'cuit' && type !== 'select' ? (
        <label htmlFor={id}>
          {label}
          <input
            id={id}
            type={type}
            defaultValue=""
            onChange={e => {
              setValue(e.target.value);
            }}
            disabled={disabled}
          />
        </label>
      ) : (
        ''
      )}
    </InputProviderWrap>
  );
};

InputProvider.propTypes = {
  label: string.isRequired,
  type: string,
  id: string.isRequired,
  value: oneOfType([string, object]),
  setValue: func,
  disabled: bool,
  onBlurValidation: func,
  setErrorMsg: func,
};

InputProvider.defaultProps = {
  setValue: () => {},
  type: 'text',
  value: {},
  disabled: false,
  onBlurValidation: () => {},
  setErrorMsg: () => {},
};

export default InputProvider;
